// extracted by css-extract-rspack-plugin
export default {"preview-container":"WidgetPreview_preview-container__q0aV0","preview-text-container":"WidgetPreview_preview-text-container__irVbh"};